// Llaves APA, valores default y límites de caracteres definidos en:
// https://www.figma.com/design/62FhL4d2NSwLCNoMsdOKYe/Llaves_ConteoCarac_MigracionClarotv?node-id=1-444
export const KEY_TITULO = 'migracionclarotv_texto_titulo';
export const DEFAULT_TITULO = '¡Claro video evoluciona a Claro tv+ en tu Smart TV!';
export const MAX_CHARS_TITULO = 55;

export const KEY_DESCRIPCION = 'migracionclarotv_texto_parrafo';
export const DEFAULT_DESCRIPCION = 'Descarga la nueva app de Claro tv+ e inicia sesión con tus credenciales de siempre para seguir disfrutando de tu contenido favorito.';
export const MAX_CHARS_PARRAFO = 155;

export const KEY_TEXTO_LEGAL = 'migracionclarotv_texto_disclaimer';
export const DEFAULT_TEXTO_LEGAL = '*Después de instalar Claro tv+, puedes borrar la app Claro video de este dispositivo.';
export const MAX_CHARS_DISCLAIMER = 100;

export const KEY_BOTON_DESCARGAR = 'migracionclarotv_boton_texto_descarga';
export const DEFAULT_BOTON_DESCARGAR = 'Descarga Claro tv+';
export const MAX_CHARS_BOTON_DESCARGA = 25;

export const KEY_BOTON_MAS_TARDE = 'migracionclarotv_boton_texto_mastarde';
export const DEFAULT_BOTON_MAS_TARDE = 'Más tarde';
export const MAX_CHARS_BOTON_MAS_TARDE = 25;

export const KEY_BACKGROUND = 'migracionclarotv_imagen_fondo';
export const KEY_LOGO = 'migracionclarotv_imagen_clarotv';

export const KEY_CONFIGS = 'migration_claro_tv_plus';
export const APP_ID_TIZEN = 'PENDIENTE_DEFINIR';
export const APP_ID_WEBOS = 'PENDIENTE_DEFINIR';
export const KEY_TIMESTAMP_MODAL = 'migration_claro_tv_plus_last_shown';
export const SUPPRESSION_WINDOW_MS = 24 * 60 * 60 * 1000;



// WEBPACK FOOTER //
// ./src/components/Modal/ModalChangeAAFToClaroTV/constants.js